import { usePlugins } from 'app/features/plugins/hooks/usePlugins';
import { awsS3CheckoutUrl } from 'app/util/constants';
import './styles.scss';

const CancelButton = () => {
  const { onCancel, showButtonCancel } = usePlugins();

  return (
    <>
      {showButtonCancel && (
        <div className='cancel-button'>
          <img className='logo-cancel' onClick={onCancel} src={`${awsS3CheckoutUrl}/Close.png`} alt='' />
        </div>
      )}
    </>
  );
};

export default CancelButton;
